import { connect } from 'react-redux';
import { getPOSData } from '@olxbr/mojo-jojo/selectors/pos';
import { getProductsData } from '@olxbr/mojo-jojo/selectors/products';
import { getCurrentContent } from '@olxbr/mojo-jojo/selectors/content';
import { compose, withProps } from 'recompose';

import Landing from './Landing';

const mapStateToProps = state => ({
  posData: getPOSData(state),
  productsData: getProductsData(state),
  contentData: getCurrentContent(state),
});

const navItems = [
  {
    text: 'Planos',
    link: 'plans',
    smooth: true,
  },
  {
    text: 'Benefícios',
    link: 'benefits',
    smooth: true,
  },
  {
    text: 'Contato',
    link: 'insidesales',
    smooth: true,
  },
  {
    text: 'Dúvidas',
    link: 'questions',
    smooth: true,
  },
];

export default compose(
  connect(mapStateToProps),
  withProps({ navItems }),
)(Landing);
